import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from '../../../../core/services/helpers.service';
import { CashAdvanceService } from '../../../../core/api/cash-advance.service';
import { MatDialog } from '@angular/material/dialog';
import { TagService } from '../../../../core/api/tag.service';
import { ExpanseCategoryService } from '../../../../core/api/expanse-category.service';
import { FileService } from '../../../../core/api/file.service';
import { LoadingService } from '../../../../core/services/loading.service';
import { ConfirmDialogComponent } from '../../../../components/confirm-dialog/confirm-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DirectiveModule } from '../../../../core/directives';
import { FilePreviewComponent } from '../../../../components/file-preview/file-preview.component';
import { AuthService } from '../../../../core/services/auth.service';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-action-cash-advance-claimer',
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    DirectiveModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './action-cash-advance-claimer.component.html',
  styleUrl: './action-cash-advance-claimer.component.scss',
})
export class ActionCashAdvanceClaimerComponent {
  m: any;
  type: any;
  id: any;
  form: FormGroup;
  tag: any[] = [];
  expenseCategory: any[] = [];
  uploadStatus: boolean = false;
  fileExists: boolean = false;
  fileUrl: any;
  file: any;
  fileName: string = '';
  uploadedFiles: any[] = [];
  maxAmount: number = 0;
  projectTagNumber: string = '';
  projectTagName: string = '';
  tagSearchTerm: string = '';
  currentUser: any;
  canCreateProjectTag: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private helpers: HelpersService,
    private fb: FormBuilder,
    private router: Router,
    private cashAdvanceService: CashAdvanceService,
    private dialog: MatDialog,
    private tagService: TagService,
    private expanseCategoryService: ExpanseCategoryService,
    private fileService: FileService,
    private loadingService: LoadingService,
    private authService: AuthService
  ) {
    this.m = this.activatedRoute.snapshot.queryParams['m'];
    this.id = this.activatedRoute.snapshot.queryParams['id'];
    this.type = this.activatedRoute.snapshot.queryParams['type'];
    this.form = this.fb.group({
      title: [null, Validators.required],
      amount: [null, Validators.required],
      currency: ['Rp', [Validators.required]],
      expenseCategoryId: [null, [Validators.required]],
      startDate: [null, [Validators.required]],
      endDate: [null, [Validators.required]],
      tagId: [null, [Validators.required]],
      desciption: [null, [Validators.required]],
      location: [null, [Validators.required]],
      fileId: [null, [Validators.required]],
      refId: [null],
    });
    this.currentUser = this.authService.getLoggedUser();
    this.canCreateProjectTag =
      this.authService.isFinance(this.currentUser) ||
      this.authService.isApprover(this.currentUser);
    this.getTag();
    this.getExpanseCategory();
    this.getDataById();
  }

  getTag() {
    this.loadingService.startLoading();
    this.tagService.getAllData().then(
      (res) => {
        this.loadingService.endLoading();
        this.tag = res;
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  get filteredTag(): any[] {
    const keyword = this.tagSearchTerm.trim().toLowerCase();
    if (!keyword) return this.tag;
    return this.tag.filter((item: any) =>
      (item?.name ?? '').toLowerCase().includes(keyword)
    );
  }

  onTagSelectOpenedChange(opened: boolean): void {
    if (!opened) this.tagSearchTerm = '';
  }

  getExpanseCategory() {
    this.loadingService.startLoading();
    this.expanseCategoryService.getAllData().then(
      (res) => {
        this.loadingService.endLoading();
        this.expenseCategory = res.filter(
          (item: any) => item.type == 'Cash Advance'
        );
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  getDataById() {
    if (this.id) {
      console.log('start get data');
      this.loadingService.startLoading();
      this.cashAdvanceService.getById(this.id).then(
        ({ cashAdvanceData, settlementData }) => {
          const data = cashAdvanceData;
          this.loadingService.endLoading();
          if (data.file) {
            this.file = data.file;
            this.fileExists = true;
            data['fileId'] = data.file.id;
            this.fileName = data.file.fileName;
            this.uploadedFiles = [data.file];
          }
          if (data.fileIds?.length && !this.uploadedFiles.length) {
            this.uploadedFiles = data.fileIds.map((id: number) => ({
              id,
              fileName: `File #${id}`,
            }));
          }
          data['expenseCategoryId'] = data.expenseCategory.id;
          data['tagId'] = data.tag.id;
          data['desciption'] = data.description;
          this.form.patchValue(data);
        },
        (error) => {
          this.loadingService.endLoading();
          this.helpers.sbError(error.message);
        }
      );
    }
  }

  cancel() {
    this.router.navigate(['/dashboard/cash-advance-claimer']);
  }

  submit(status: string) {
    if (this.form.valid) {
      const data = this.form.value;
      data['status'] = status;
      data['amount'] = this.helpers.parseAmount(data.amount);
      if (this.uploadedFiles.length) {
        data['fileIds'] = this.uploadedFiles.map((item: any) => item.id);
        data['fileId'] = this.uploadedFiles[0].id;
      }
      this.dialog
        .open(ConfirmDialogComponent, {
          width: '545px',
          maxHeight: '95vh',
          panelClass: 'confirm-dialog',
          data: {
            title: `Confirm ${
              this.m == 'add' ? 'Add New Cash Advance' : 'Edit Cash Advance'
            }`,
            message: `Changes to the Cash Advance cannot be undone once saved. Are you sure you want to proceed?`,
          },
        })
        .afterClosed()
        .subscribe((result: any) => {
          if (result) {
            if (this.m == 'add') {
              this.loadingService.startLoading();
              this.cashAdvanceService
                .insert(data)
                .then(() => {
                  this.loadingService.endLoading();
                  this.helpers.sbSuccess('Cash Advance berhasil ditambahkan!');
                  this.router.navigate(['/dashboard/cash-advance-claimer']);
                })
                .catch((error) => {
                  this.loadingService.endLoading();
                  this.helpers.sbError(error.message);
                });
            } else if (
              this.m == 'edit' &&
              this.type &&
              this.type == 'resubmit' &&
              this.id
            ) {
              this.loadingService.startLoading();
              data['isResubmit'] = true;
              data['description'] = data['desciption'];
              data['expanseCategoryId'] = data['expenseCategoryId'];
              this.cashAdvanceService
                .updateById(this.id, data)
                .then(() => {
                  this.loadingService.endLoading();
                  this.helpers.sbSuccess('Berhasil resubmit Cash Advance!');
                  this.router.navigate(['/dashboard/cash-advance-claimer']);
                })
                .catch((error) => {
                  this.loadingService.endLoading();
                  this.helpers.sbError(error.message);
                });
            } else if (this.m == 'edit' && this.id) {
              this.loadingService.startLoading();
              data['isResubmit'] = false;
              data['description'] = data['desciption'];
              data['expanseCategoryId'] = data['expenseCategoryId'];
              this.cashAdvanceService
                .updateById(this.id, data)
                .then(() => {
                  this.loadingService.endLoading();
                  this.helpers.sbSuccess('Cash Advance berhasil diperbarui!');
                  this.router.navigate(['/dashboard/cash-advance-claimer']);
                })
                .catch((error) => {
                  this.loadingService.endLoading();
                  this.helpers.sbError(error.message);
                });
            }
          }
        });
    } else if (this.form.get('fileId')?.invalid) {
      this.helpers.sbError(
        'Please upload file firstly and fill all required fields!'
      );
    } else {
      this.helpers.sbError('Lengkapi form terlebih dahulu!');
    }
  }

  uploadFile(event: Event) {
    this.uploadStatus = true;
    const target = event.target as HTMLInputElement | null;
    const fileList = target?.files;
    if (fileList?.length) {
      const files = Array.from(fileList);
      const uploads = files.map(
        (file) =>
          new Promise<any>((resolve, reject) => {
            try {
              this.fileService.upload(file).subscribe({
                next: (res: any) => {
                  if (
                    res?.type === HttpEventType.Response &&
                    res?.body?.data
                  ) {
                    resolve(res.body.data);
                  }
                },
                error: (err: any) => reject(err),
              });
            } catch (err: any) {
              reject(err);
            }
          })
      );

      this.loadingService.startLoading();
      Promise.all(uploads)
        .then((results: any[]) => {
          const uploaded = results.filter(Boolean);
          if (!uploaded.length) return;

          this.uploadedFiles = [...this.uploadedFiles, ...uploaded];
          this.file = this.uploadedFiles[0];
          this.fileName =
            this.uploadedFiles.length === 1
              ? this.uploadedFiles[0].fileName
              : `${this.uploadedFiles.length} files selected`;
          this.form.get('fileId')?.setValue(this.uploadedFiles[0].id);
          this.fileExists = true;
          this.helpers.sbSuccess('File berhasil diupload');
        })
        .catch((err: any) => {
          this.helpers.sbError(err.message);
        })
        .finally(() => {
          this.loadingService.endLoading();
          this.uploadStatus = false;
          if (target) target.value = '';
        });
    } else {
      this.helpers.sbError('Tidak ada file yang akan diupload!');
      this.uploadStatus = false;
      if (target) target.value = '';
    }
  }

  download(fileItem?: any) {
    const targetFile = this.helpers.resolveTargetFile(fileItem, this.file);
    if (targetFile?.id) {
      this.dialog
        .open(FilePreviewComponent, {
          width: '70vw',
          maxWidth: '70vw',
          maxHeight: '95vh',
          data: targetFile,
        })
        .afterClosed()
        .subscribe((item) => {
          if (item) {
          }
        });
    } else {
      this.helpers.sbError('Tidak ada file yang bisa diunduh');
    }
  }

  removeUploadedFile(index: number): void {
    this.uploadedFiles.splice(index, 1);
    if (!this.uploadedFiles.length) {
      this.file = null;
      this.fileName = '';
      this.fileExists = false;
      this.form.get('fileId')?.setValue(null);
      return;
    }

    this.file = this.uploadedFiles[0];
    this.fileName =
      this.uploadedFiles.length === 1
        ? this.uploadedFiles[0].fileName
        : `${this.uploadedFiles.length} files selected`;
    this.form.get('fileId')?.setValue(this.uploadedFiles[0].id);
  }

  setMaxAmount(data: any): void {
    const found = this.expenseCategory.find((item) => item.id === data.value);
    if (found) {
      this.maxAmount = found.max_transaction_value;

      const amountControl = this.form.get('amount');
      if (this.maxAmount != 0 && amountControl) {
        amountControl.setValidators([
          Validators.required,
          Validators.max(this.maxAmount),
        ]);
        amountControl.updateValueAndValidity();
      } else if (this.maxAmount == 0 && amountControl) {
        amountControl?.setValidators([Validators.required]);
        amountControl?.updateValueAndValidity();
      }
    }
  }

  createProjectTag(): void {
    const projectNumber = this.projectTagNumber.trim();
    const projectName = this.projectTagName.trim();
    if (!projectNumber || !projectName) {
      this.helpers.sbError('Nomor Project dan Nama Project wajib diisi');
      return;
    }
    const name = `${projectNumber} - ${projectName}`;

    const payload = {
      name,
      budget: 0,
      description: `Tag Nomor Project - ${name}`,
      teams: [],
      expanse_categories: [],
    };

    this.loadingService.startLoading();
    this.tagService
      .insert(payload)
      .then((createdTag: any) => {
        this.tag.push(createdTag);
        this.form.get('tagId')?.setValue(createdTag.id);
        this.projectTagNumber = '';
        this.projectTagName = '';
        this.helpers.sbSuccess('Tag Nomor Project berhasil ditambahkan');
      })
      .catch((error) => {
        this.helpers.sbError(error.message);
      })
      .finally(() => {
        this.loadingService.endLoading();
      });
  }
}
